package com.ives.modules.ecg;

import haxe.Timer;

import js.Browser;
import js.html.OptionElement;

import com.ives.modules.ecg.ECGLineView;
import com.ives.modules.cine.Cine;
import com.ives.components.workspace.DicomWorkspace;
import com.ives.utils.math.MathStats;
import com.ives.utils.Remoting;

class ECG extends Module{
	static private inline var ECG_MODALITY:String = "ECG";

	static public inline var ECG_EVENT:String = "ECG_EVENT";

	static private inline var DELAY:UInt = 20; // 50 FPS

	private var ecgDatas:Array<ECGData>;
	private var showRequested:Bool = false;
	private var currentIndex:UInt = 0;
	private var lineViews:Array<ECGLineView> = [];
	private var totalTime:Float;
	private var ratio:Float = 0;
	private var timer:Timer;

	private var selectedECGData:ECGData;

	override public function handleModuleEvent(event:ModuleEvent){
		if(event.type == DicomWorkspace.WORKSPACE_READY){
			Remoting.ecgData(dicomWorkspace.dicomImageData.sourceName, dicomWorkspace.dicomImageData.id, onECGData);

			ecgs.addEventListener('change', onSelectChange);

			on(play, "click", onPlay);
		}

		if(event.type == ECG_EVENT){
			if(ecgContainer.classList.contains("show"))
				hideECG();
			else{
				if(ecgDatas == null)
					showRequested = true;
				else
					showECG();
			}
		}

		if(event.type == Cine.CINE_SKIP){
			ratio = event.data[0] / event.data[1];

			for(line in lineViews)
				line.update(ratio);

			time.innerHTML = '${MathStats.roundTo(ratio * totalTime, 2)} s./';
		}
	}

	private function onPlay(){
		if(timer == null)
			timer = Timer.delay(step, DELAY);
		else{
			timer.stop();

			timer = null;
		}
	}

	private function step(){
		if(timer == null)
			return;

		ratio = ((ratio * totalTime) + (DELAY / 1000)) / totalTime;

		while(ratio > 1)
			ratio -= 1;

		for(line in lineViews)
			line.update(ratio);

		time.innerHTML = '${MathStats.roundTo(ratio * totalTime, 2)} s./';

		timer = Timer.delay(step, DELAY);
	}

	private function hideECG(){
		ecgContainer.classList.remove("show");
	}

	private function onECGData(ecgDatas:Array<ECGData>){
		this.ecgDatas = ecgDatas;

		if(ecgDatas != null){
			dicomViewer.ecgButton.style.display = "";

			//if(showRequested || dicomWorkspace.dicomImageData.modality == ECG_MODALITY)
				showECG();
		}
	}

	private function onSelectChange(){
		for(ecgData in ecgDatas){
			if(ecgs.value == '${ecgData.label} (${ecgData.originality})'){
				selectedECGData = ecgData;

				clear();

				totalTime = ecgData.lines[0].values.length / ecgData.samplingFrequency;

				info.innerHTML = '${MathStats.roundTo(totalTime, 2)} s., ${ecgData.samplingFrequency} Hz';
				time.innerHTML = '${MathStats.roundTo(0, 2)} s./';

				lineViews = [];

				for(line in ecgData.lines){
					var view:ECGLineView = new ECGLineView(line);

					trace('min ${line.min}, max ${line.max}');

					append(view);

					lineViews.push(view);

					view.init(ratio);
				}

				break;
			}
		}
	}

	private function showECG(){
		if(ecgDatas == null)
			return;

		clear();
		clear(ecgs);

		ecgContainer.style.display = "flex";
		ecgContainer.classList.add("show");

		for(ecgData in ecgDatas){
			var option:OptionElement = Browser.document.createOptionElement();

			option.innerHTML = option.value = '${ecgData.label} (${ecgData.originality})';

			ecgs.appendChild(option);
		}

		onSelectChange();
	}
}
